import {readCookie} from '@Utils/cookie.util';

export const CSRF_TOKEN_HEADER = 'X-CSRF-TOKEN';

const CSRF_COOKIE_NAME = 'csrf_cookie';
const CSRF_TOKEN_NAME_META_SELECTOR = 'meta[name="data-csrf-name"]';
const DEFAULT_CSRF_TOKEN_NAME = 'csrf_token';

/**
 * The token PMW.write sends: read from the csrf cookie, or fetched from authenticate/getCsrfData when the cookie is missing.
 */
export const getCsrfToken = async (): Promise<string> => {
  return window.PMW.getCsrfToken((token: string): string => {
    return token;
  });
};

/**
 * The token from the csrf cookie, read synchronously for requests that cannot await getCsrfToken (sendBeacon on
 * navigate-away). Null when the cookie is missing.
 */
export const readCsrfTokenFromCookie = (): string | null => {
  return readCookie(CSRF_COOKIE_NAME);
};

export const getCsrfTokenName = (): string => {
  return document.querySelector<HTMLMetaElement>(CSRF_TOKEN_NAME_META_SELECTOR)?.content ?? DEFAULT_CSRF_TOKEN_NAME;
};
